<div class="container" [ngStyle]="{ background: backgroundColor() }">
  <orbit-title [textValue]="titleValue()" size="lg" />
</div>
